
import { Estimation, Validation, ValidationFilter_2 } from "@/types/estimation.type";
import { Parameter } from "@/types/parameter.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { defineComponent, PropType, reactive } from "@vue/runtime-core";
import { dateFormatDate } from "@/utils/date.utils";
import { Pagination } from "@/types/pagination.type";
import {
  downloadReportValidation_2,
  getValidation_2,
  getPaginatedEstimations,
} from "@/service/estimation.service";

import { DataUpload } from "@/types/dataupload.type";
import { downloadFile } from "@/utils/blob.util";

export default defineComponent({
  components: {},
  props: {
    samplingPoint: {
      type: Object as PropType<SamplingPoint>,
      rquired: true,
      immediate: true,
      deep: true,
    },

    parameter: {
      type: Object as PropType<Parameter>,
      required: true,
      immediate: true,
      deep: true,
    },
    dataUpload: {
      type: Object as () => DataUpload[],
      required: false,
      immediate: true,
      deep: true,
    },

    startDate: { type: Date, required: false, immediate: true, deep: true },
    endDate: { type: Date, required: false, immediate: true, deep: true },
  },
  watch: {
    dataUpload: function () {
      this.refreshValidation();
    },
  },
  setup() {
    const dataValidation = reactive<Pagination<Validation>>({
      data: [],
      totalRows: 0,
      currentPage: 0,
      rowPerPage: 0,
      offset: 0,
    });
    const paginatedEstimations = reactive<Pagination<Estimation>>({
      data: [],
      totalRows: 0,
      currentPage: 0,
      rowPerPage: 0,
      offset: 0,
    });
    return { dateFormatDate, dataValidation, paginatedEstimations };
  },
  data() {
    return {
      // dataValidation: {} as Pagination<Validation>,
      showOpendata: false,
      currentPage: 1 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
      dataPagination: [] as DataUpload[],
      estimations: [] as Estimation[],
      dataPagination_2: [] as Estimation[],
      //paginatedEstimations: [] as Estimation[],
    };
  },
  mounted() {
    this.refreshValidation();
  },
  methods: {
    async refreshValidation() {
      await this.getEstimations(); //se obtienen estimaciones

      //this.getDataPagination(); // no hace nada
      await this.getDataPaginationEstimation(); // se paginan las estimaciones

      if (this.samplingPoint && this.parameter && this.dataUpload) {
        const validationFilter = {
          samplingPointId: [this.samplingPoint.id],
          parameterId: [this.parameter.id],
          date: [this.startDate, this.endDate],
        } as ValidationFilter_2;

        Object.assign(
          this.dataValidation,
          await getValidation_2(
            this.currentPage,
            this.rowPerPage,
            validationFilter,
            this.dataPagination_2,
            this.dataUpload
          )
        );

        this.dataValidation.totalRows = this.dataValidation.data.length;
      }
    },

    /**
     * set page
     * @param {number} page
     */
    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.refreshValidation();
    },
    /**
     * change page
     * @param {number} page
     */
    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshValidation();
    },

    getDataPagination() {
      if (this.dataUpload && this.dataUpload.length > 0) {
        this.totalRows = this.dataUpload.length;
        this.dataPagination = [];

        let size = (this.currentPage - 1) * this.rowPerPage;
        const condition =
          (this.totalRows - (this.currentPage - 1) * this.rowPerPage) / this.rowPerPage;
        let skip;
        if (condition >= 1) {
          skip = size + this.rowPerPage;
        } else {
          skip = condition * 10 + size;
        }
        if (size <= this.dataUpload.length) {
          for (let i = size; i < skip; i++) {
            if (this.dataUpload[i].dateTime) {
              this.dataPagination.push(this.dataUpload[i]);
            }
          }
        }
      }
    },
    getDataPaginationEstimation() {
      if (this.estimations && this.estimations.length > 0) {
        this.totalRows = this.estimations.length;
        this.dataPagination_2 = [];

        let size = (this.currentPage - 1) * this.rowPerPage;
        const condition =
          (this.totalRows - (this.currentPage - 1) * this.rowPerPage) / this.rowPerPage;
        let skip;
        if (condition >= 1) {
          skip = size + this.rowPerPage;
        } else {
          skip = condition * 10 + size;
        }
        if (size <= this.estimations.length) {
          for (let i = size; i < skip; i++) {
            if (this.estimations[i].dateTime) {
              this.dataPagination_2.push(this.estimations[i]);
            }
          }
        }
      }
    },
    async getEstimations() {
      if (this.samplingPoint && this.parameter) {
        const validationFilter = {
          samplingPointId: [this.samplingPoint.id],
          parameterId: [this.parameter.id],
          date: [this.startDate, this.endDate],
        } as ValidationFilter_2;

        this.estimations = await getPaginatedEstimations(validationFilter);
      }
    },

    async downloadCSV() {
      if (this.dataUpload && this.estimations) {
        const reportFilter = {
          samplingPointId: [this.samplingPoint?.id],
          parameterId: [this.parameter.id],
          date: [this.startDate, this.endDate],
        } as ValidationFilter_2;
        // const validation = await getValidation(undefined, undefined, reportFilter, this.dataUpload);
        const data = await downloadReportValidation_2(
          reportFilter,
          this.dataUpload,
          this.estimations
        );

        downloadFile(data.url, data.fileName);
      }
    },
  },
});
